let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l8LQp")).then(() => parcelRequire('jk4YF'));